// extracted by mini-css-extract-plugin
export var cardContainer = "_q4-0";
export var cardHeader = "_q4-2";
export var collapsedState = "_q4-3";
export var dragHandle = "_q4-5";
export var dragHandleIcon = "_q4-6";
export var dragging = "_q4-1";
export var titleArea = "_q4-4";